const config = window.AbdelmegedTheme || {};
const languageKey = config.storageKeys?.language || 'abdelmeged_language';
const directionKey = config.storageKeys?.direction || 'abdelmeged_direction';
const buttons = document.querySelectorAll('[data-language-toggle]');
const languages = ['ar', 'en'];
const directions = {
  ar: 'rtl',
  en: 'ltr',
};
const unavailableMessage = {
  ar: 'الترجمة غير متاحة بعد',
  en: 'Translation is not available yet',
};

const setCookie = (name, value) => {
  document.cookie = `${encodeURIComponent(name)}=${encodeURIComponent(value)}; path=/; max-age=31536000; samesite=lax`;
};

const getStored = (key) => {
  try {
    return localStorage.getItem(key);
  } catch {
    return null;
  }
};

const setStored = (key, value) => {
  try {
    localStorage.setItem(key, value);
  } catch {
    // Local storage may be unavailable in private contexts.
  }

  setCookie(key, value);
};

const normalizeLanguage = (language) => (
  languages.includes(language) ? language : 'ar'
);

const applyLanguage = (language) => {
  const normalized = normalizeLanguage(language);
  const direction = directions[normalized];
  const html = document.documentElement;

  html.lang = normalized === 'en' ? 'en-US' : 'ar';
  html.dir = direction;
  html.dataset.language = normalized;
  html.dataset.direction = direction;

  setStored(languageKey, normalized);
  setStored(directionKey, direction);

  buttons.forEach((button) => {
    const label = button.querySelector('[data-language-toggle-label]');
    const status = button.querySelector('[data-language-toggle-status]');
    const nextLanguage = normalized === 'ar' ? 'EN' : 'AR';

    button.dataset.currentLanguage = normalized;
    button.dataset.currentDirection = direction;
    button.dataset.targetLanguage = normalized === 'ar' ? 'en' : 'ar';

    if (label) {
      label.textContent = nextLanguage;
    }

    if (status) {
      status.textContent = '';
    }
  });

  window.dispatchEvent(new CustomEvent('abdelmeged:languagechange', {
    detail: {
      language: normalized,
      direction,
    },
  }));
};

const reloadWithLanguage = (language) => {
  const normalized = normalizeLanguage(language);
  const alternateUrl = config.alternateUrls?.[normalized];

  if (alternateUrl) {
    window.location.assign(alternateUrl);
    return;
  }

  const url = new URL(window.location.href);

  url.searchParams.set('lang', normalized);
  url.searchParams.set('dir', directions[normalized]);
  window.location.assign(url.toString());
};

const currentLanguage = () => normalizeLanguage(
  config.language || getStored(languageKey) || document.documentElement.lang.slice(0, 2)
);

const toggleLanguage = () => {
  const nextLanguage = currentLanguage() === 'ar' ? 'en' : 'ar';
  const alternateUrl = config.alternateUrls?.[nextLanguage];

  if (!alternateUrl && Object.keys(config.alternateUrls || {}).length > 0) {
    buttons.forEach((button) => {
      const status = button.querySelector('[data-language-toggle-status]');

      if (status) {
        status.textContent = unavailableMessage[nextLanguage] || unavailableMessage.en;
      }
    });

    window.dispatchEvent(new CustomEvent('abdelmeged:interaction', { detail: { type: 'language' } }));
    return;
  }

  applyLanguage(nextLanguage);
  window.dispatchEvent(new CustomEvent('abdelmeged:interaction', { detail: { type: 'language' } }));
  reloadWithLanguage(nextLanguage);
};

if (config.features?.languageSwitching !== false) {
  applyLanguage(currentLanguage());
  buttons.forEach((button) => button.addEventListener('click', toggleLanguage));
}
